const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:3000';
};

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-1_Ehopq7RZi',
      userPoolClientId: '12gcr2gs95s5s8vlatcknusr24',
      loginWith: {
        oauth: {
          domain: 'main-auth-u9rfxj02.auth.ap-southeast-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [`${getBaseUrl()}/callback`],
          redirectSignOut: [getBaseUrl()],
          responseType: 'code' as const
        }
      }
    }
  }
};